module.exports = __webpack_public_path__ + "static/that-watch-shop-7863351d926ab08a63f4f3089072c72c.png";